import { itemQuantity } from '../../../../shared/item-count.js'

// A quote line's prices are per unit. A Qty 2 line at BP £432 is an offer of
// £864 (CONTEXT.md). These helpers work the line totals out in pence, so
// £0.1 x 3 is £0.3 and not 0.30000000000000004.

/** Pence for a unit price, or null when the price is missing or not above zero. */
function unitPence(price) {
  if (price == null || String(price).trim() === '') return null
  const pounds = Number(price)
  if (!Number.isFinite(pounds) || pounds <= 0) return null
  return Math.round(pounds * 100)
}

function totalPounds(price, units) {
  const pence = unitPence(price)
  return pence == null ? null : (pence * units) / 100
}

/** The whole-line sell and buy totals in pounds. A missing price gives a null total. */
export function lineTotals(qty, sp, bp) {
  const units = itemQuantity({ quantity: qty })
  return { totalSp: totalPounds(sp, units), totalBp: totalPounds(bp, units) }
}

/** "£1,800" for a whole amount, "£864.50" when there are pence. */
export function formatLinePounds(pounds) {
  const hasPence = Math.round(pounds * 100) % 100 !== 0
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: hasPence ? 2 : 0,
    maximumFractionDigits: 2,
  }).format(pounds)
}
